/* src/app/views/collection/shared/collection-display-selection-group/location-display-selection-group.component.scss */
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f6px {
  font-size: 0.375rem;
}
.f8px {
  font-size: 0.5rem;
}
.f10px {
  font-size: 0.625rem;
}
.f11px {
  font-size: 0.6875rem;
}
.f12px {
  font-size: 0.75rem;
}
.f13px {
  font-size: 0.8125rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.province-name {
  font-size: 0.75rem;
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #222222;
}
.location-address {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  color: #9fa2ad;
}
.checked-count {
  margin-left: 0.25rem;
  font-size: 0.6rem;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.n-selected {
  width: 1.5rem;
}
/*# sourceMappingURL=location-display-selection-group.component.css.map */
